import { OnChallengeCompletedData, OnChallengeInvalidatedData } from '../interface';

export enum ProofOfWorkActionType {
  SET_CHALLENGE_COMPLETED,
  SET_CHALLENGE_INVALIDATED
}

export type ProofOfWorkAction =
  | {
      type: ProofOfWorkActionType.SET_CHALLENGE_COMPLETED;
      onChallengeCompletedData: OnChallengeCompletedData;
    }
  | {
      type: ProofOfWorkActionType.SET_CHALLENGE_INVALIDATED;
      onChallengeInvalidatedData: OnChallengeInvalidatedData;
    };
